import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import TransitionLink from 'components/transition-link/transition-link';
import moment from 'moment';
import classNames from 'classnames';
import Text from 'components/text/text';
import Button from 'components/button/button';
import GridRow from 'components/grid/grid-row';
import GridCol from 'components/grid/grid-col';
import messages from './messages';

class SingleSession extends Component {
  constructor(props) {
    super();
  }

  _renderImage() {
    const image = this.props.data.session_type === 'unknown' ? '' : (
      <img
        src={this.props.data.image}
        alt="3D Render"
        className="img img_md mix-img_centered"
        key={this.props.data.uuid}
      />
    );

    return (
      <GridCol desktop="6" mobile="4" tablet="8" tabletLg="4" height="med">
        <div className="staggered staggered_right">
          {image}
        </div>
      </GridCol>
    );
  }

  _renderDownloadButton() {
    if (!this.props.data.downloadPdf) return;

    const { intl } = this.props;

    return (
      <div className="set-bd set-bd_separated">
        <Button
          className="mix-btn_mobile"
          theme="dark"
        >
          {intl.formatMessage(messages.download_pdf_cta_label)}
        </Button>
      </div>
    );
  }

  _renderInfo() {
    const { intl } = this.props;
    const googleMapsSearch = `https://www.google.com/maps/search/${this.props.data.shop_name}+${this.props.data.shop_city}+${this.props.data.shop_state}`;

    return (
      <GridCol desktop="6" mobile="4" tablet="8" tabletLg="4">
        <div className="infoHighlight">
          <div className="infoHighlight-bar">
            <span className="infoHighlight-bar-top"></span>
            <span className="infoHighlight-bar-bottom"></span>
          </div>
          <div className="infoHighlight-info infoHighlight-info_enlargeBar infoHighlight-info_alignTop">
            <div className="set set_isolated_mdLg mix-set_narrow js-timeline-point">
              <div className="set-hd">
                <Text
                  type="reg"
                  color="DefaultGray"
                  >
                  {intl.formatDate(this.props.data.updated_at, { 'year': 'numeric', 'month': 'numeric', 'day': '2-digit' })}
                </Text>
              </div>
              <div className="set-bd">
                <Text
                  type="lg"
                  className="mix-txt_uppercaseLg"
                  >
                  {this.props.data.session_name}
                </Text>
              </div>
              <div className="set-bd">
                <TransitionLink
                  to={googleMapsSearch}
                  target="_blank"
                  className="txt txt_md mix-txt_colorDefaultBlue"
                  >
                  {this.props.data.shop_name} <span className="txt mix-txt_colorDefaultGray">&bull;</span> {this.props.data.shop_city}
                </TransitionLink>
              </div>
              <div className="set-bd">
                <Text
                  type="reg"
                  color="DefaultGray"
                  className="mix-txt_capitalize"
                  >
                  {this.props.data.employee_name}
                </Text>
              </div>
              {this._renderDownloadButton()}
            </div>
          </div>
        </div>
      </GridCol>
    );
  }

  render() {
    return (
      <div className="box box_padVertLg">
        <GridRow className="mix-grid_vertCenter">
          {this._renderImage()}
          {this._renderInfo()}
        </GridRow>
      </div>
    );
  }
}

export default injectIntl(SingleSession);



// WEBPACK FOOTER //
// ./src/client/pages/sessions/_single-session.jsx